var Global = {
    url: "https://hecze-anecdotes.fly.dev"
}

export default Global;